import React, { useState,useRef,useEffect } from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import AddUserLayer from "../components/AddUserLayer";
import { Icon } from "@iconify/react/dist/iconify.js";
import Select from 'react-select'
import { GoogleMap, useJsApiLoader, Autocomplete } from '@react-google-maps/api';
import { API_URL } from "..";
import mapboxgl from "mapbox-gl";
import MapboxGeocoder from "@mapbox/mapbox-gl-geocoder";
import "@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css";
import "mapbox-gl/dist/mapbox-gl.css";
import {  useMapbox } from "../GoogleMapsContext";

const AddAffiliates = () => {
 
  const [imagePreviewUrl, setImagePreviewUrl] = useState("");
  const [phone, setPhone] = useState("");
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [showAlertMessage, setshowAlertMessage] = useState({
    status:false,
    message:'',
    desc:''
  });
  const { mapboxgl } = useMapbox();

  const [selectedPlace, setSelectedPlace] = useState(null);
  const autocompleteRef = useRef(null);
  // if (!isLoaded) return <div>Loading...</div>;
  const [isMounted, setIsMounted] = useState(false);
  const incidentGeocoderRef = useRef(null);
  
  
  useEffect(() => {
    setIsMounted(true);
    return () => {
      setIsMounted(false);
      // Cleanup geocoders when unmounting
      if (incidentGeocoderRef.current) {
        incidentGeocoderRef.current.onRemove();
        incidentGeocoderRef.current = null;
      }
    };
  }, []);
  useEffect(() => {
    if (!isMounted || !mapboxgl.accessToken) return;

    // Clear existing containers
    const clearContainer = (id) => {
      const container = document.getElementById(id);
      if (container) container.innerHTML = '';
      return container;
    };

    const incidentContainer = clearContainer('incident-location-container');

    if (!incidentContainer ) return;

    // Initialize geocoders with fresh instances
    incidentGeocoderRef.current = new MapboxGeocoder({
      accessToken: mapboxgl.accessToken,
      mapboxgl: mapboxgl,
      placeholder: 'Enter business location',
      marker: false,
      
    });

    // Add to DOM
    incidentGeocoderRef.current.addTo(incidentContainer);
    incidentGeocoderRef.current.on('result', (e) => {
      const { place_name, center } = e.result;
      setSelectedPlace({
        address: place_name,
        lat: center[1],
        lng: center[0],
        name: place_name.split(',')[0]
      });
  
    });

    return () => {
      if (incidentGeocoderRef.current) {
        incidentGeocoderRef.current.onRemove();
      }
   
    };
  }, [isMounted]);
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreviewUrl(reader.result);
      };
      reader.readAsDataURL(file);
    }
    
  };
  

  const options = [
    { value: 'Light Duty Towing', label: 'Light Duty Towing' },
    { value: 'Medium Duty Towing', label: 'Medium Duty Towing' },
    { value: 'Heavy Duty Towing', label: 'Heavy Duty Towing' },
    { value: 'Flatbed Towing', label: 'Flatbed Towing' },
    { value: 'Motorcycle Towing', label: 'Motorcycle Towing' },
    { value: 'Long-Distance Towing', label: 'Long-Distance Towing' },
    { value: 'Emergency Towing', label: 'Emergency Towing' },
    { value: 'Accident Recovery', label: 'Accident Recovery' },
    { value: 'Winch-Out Services', label: 'Winch-Out Services' },
    { value: 'Roadside Assistance', label: 'Roadside Assistance' },
    { value: 'Fuel Delivery', label: 'Fuel Delivery' },
    { value: 'Lockout Services', label: 'Lockout Services' },
    { value: 'Tire Change Services', label: 'Tire Change Services' },
    { value: 'Jump Start Services', label: 'Jump Start Services' },
    { value: 'Impound Towing', label: 'Impound Towing' },
    { value: 'Specialty Vehicle Towing', label: 'Specialty Vehicle Towing' },
    { value: 'Classic Car Towing', label: 'Classic Car Towing' },
    { value: 'Fleet Services', label: 'Fleet Services' },
    { value: 'Commercial Towing', label: 'Commercial Towing' },
    { value: 'Recreational Vehicle Towing', label: 'Recreational Vehicle Towing' },
];



function isValidEmail(email) {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
}
  const handleChange = (selected) => {
    setSelectedOptions(selected || []);
  };
  const onFormSubmit = async (event) =>{
    event.preventDefault();
    
    if(event.target.elements.business_name.value.length < 3){
      setshowAlertMessage({
        message: 'error',
        status:true,
        desc: 'Invalid business name'
      })
    }
    else if(isValidEmail(event.target.elements.email.value) === false){
      setshowAlertMessage({
        message: 'error',
        status:true,
        desc: 'Email Address is invalid'
      })
    }
    else if(phone === ""){
      setshowAlertMessage({
        message: 'error',
        status:true,
        desc: 'Phone Number is invalid'
      })
    }
    else if(event.target.elements.password.value.length  < 6){
      setshowAlertMessage({
        message: 'error',
        status:true,
        desc: 'Password is too short. It must be greater than 6 characters'
      })
    }
    else if(selectedOptions.length === 0){
      setshowAlertMessage({
        message: 'error',
        status:true,
        desc: 'Select the services that affiliate provided'
      })
    }else{

      let headersList = {
        "Accept": "*/*",
        "Content-Type": "application/json"
       }
       
       let bodyContent = JSON.stringify({
        
         "business_name": event.target.elements.business_name.value,
         "email": event.target.elements.email.value,
         "phone": phone,
         "password": event.target.elements.password.value,
         "no_of_trucks": event.target.elements.no_of_trucks.value,
         "address": selectedPlace?.address,
         "map_location": selectedPlace.lat +','+selectedPlace.lng,
         "working_area" : event.target.elements.working_area.value,
         "services_provided" : selectedOptions.map((e)=>e.value).toString(),
         "description": event.target.elements.description.value
       });
       
       let response = await fetch(API_URL+"/api/affiliates/signup", { 
         method: "POST",
         body: bodyContent,
         headers: headersList
       });
       
       let data = await response.json();
       if(response.status == 201){
        setshowAlertMessage({
          message: 'success',
          status:true,
          desc: "Affiliates Is added successfully"
        });
        event.target.elements.business_name.value= ''
        event.target.elements.email.value= ''
        setPhone('')
        event.target.elements.password.value= ''
        event.target.elements.no_of_trucks.value= ''
        event.target.elements.address.value= ''
        setSelectedPlace(null)
        event.target.elements.working_area.value = ''
        setSelectedOptions([])
        event.target.elements.description.value= ''
       }else{
        setshowAlertMessage({
          message: 'error',
          status:true,
          desc:"Error while adding new affiliates" 
        });
       }
    }
     
  }
  const onLoad = (autocomplete) => {
    autocompleteRef.current = autocomplete;
  };

  const onPlaceChanged = () => {
    if (autocompleteRef.current) {
      const place = autocompleteRef.current.getPlace();
      setSelectedPlace({
        name: place.name,
        address: place.formatted_address,
        lat: place.geometry?.location?.lat(),
        lng: place.geometry?.location?.lng(),
      });
    }
  };
  const formatPhoneNumber = (value) => {
    // Remove all non-digit characters
    const cleaned = value.replace(/\D/g, "");

    // Format the number as (XXX) XXX-XXXX
    const match = cleaned.match(/^(\d{0,3})(\d{0,3})(\d{0,4})$/);

    if (!match) return value;

    const formatted = [
      match[1] && `(${match[1]}`,
      match[2] && `) ${match[2]}`,
      match[3] && `-${match[3]}`,
    ]
      .filter(Boolean)
      .join("");

    return formatted;
  };
  const handleInputChange = (e) => {
    const formattedPhone = formatPhoneNumber(e.target.value);
    setPhone(formattedPhone);
  };
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title="Add Affiliate" />

        {/* AddUserLayer */}
        <div className="card h-100 p-0 radius-12">
          <div className="card-body p-24">
            <div className="row justify-content-center">
              <div className="col-xxl-6 col-xl-8 col-lg-10">
                <div className="card border">
                  <div className="card-body">
                   
                    {/* Upload Image Start */}

                    {/* Upload Image End */}
                    <form onSubmit={(event)=>onFormSubmit(event)}>
             

                      <div className="mb-20">
                        <label
                          htmlFor="name"
                          className="form-label fw-semibold text-primary-light text-sm mb-8"
                        >
                          Business Name <span className="text-danger-600">*</span>
                        </label>
                        <input
                          type="text"
                          name="business_name"
                          className="form-control radius-8"
                          id="name"
                          
                          placeholder="Enter Full Name"
                        />
                      </div>

                      <div className="mb-20">
                        <label
                          htmlFor="email"
                          className="form-label fw-semibold text-primary-light text-sm mb-8"
                        >
                          Email Address
                        </label>
                        <input
                          type="email"
                          name="email"
                          className="form-control radius-8"
                          id="email"
                          
                          placeholder="Enter email address"
                        />
                      </div>
                      <div className="mb-20">
                        <label
                          htmlFor="email"
                          className="form-label fw-semibold text-primary-light text-sm mb-8"
                        >
                          Password
                        </label>
                        <input
                          type="password"
                          name="password"
                          className="form-control radius-8"
                          id="password"
                          
                          placeholder="Enter password"
                        />
                      </div>
                      <div className="mb-20">
                        <label
                          htmlFor="phone"
                          className="form-label fw-semibold text-primary-light text-sm mb-8"
                        >
                          Phone <span className="text-danger-600">*</span>
                        </label>
                        <input
                          type="tel"
                          name="phone"
                          value={phone}
                          onChange={handleInputChange}
                          className="form-control radius-8"
                          id="phone"
                          
                          placeholder="Enter Phone Number"
                        />
                      </div>
                      <div className="mb-20">
                       
                          
                            <label
                              htmlFor="address"
                              className="form-label fw-semibold text-primary-light text-sm mb-8"
                            >
                              Address
                            </label>
                              <div>
   
                              <div 
                            id="incident-location-container"
                            key={`incident-${isMounted}`} // Force re-creation
                            style={{ minHeight: '50px' }}
                          />
                          <input
                            type="hidden"
                            name="address"
                            value={selectedPlace?.address || ''}
                            required
                          />

    
    </div>
                          
                         
                        
                      </div>
                      <div className="mb-20">
                        <label
                          htmlFor="assigned_to"
                          className="form-label fw-semibold text-primary-light text-sm mb-8"
                        >
                          No of Trucks
                          
                        </label>
                        <input
                          type="number"
                          name="no_of_trucks"
                          min={1}
                          className="form-control radius-8"
                          id="no_of_trucks"
                          
                          placeholder="Enter no of trucks"
                        />
                        <input
                          type="hidden"
                          name="working_area"
                          className="form-control radius-8"
                          id="working_area"
                          placeholder="Working Area"
                        />
                      </div>
                    
                    
                      <div className="mb-20">
                        <label
                          htmlFor="desc"
                          className="form-label fw-semibold text-primary-light text-sm mb-8"
                        >
                          Services that your affiliate provides
                        </label>
                        <Select
                            options={options}
                            isMulti
                            value={selectedOptions}
                            onChange={handleChange}
                            placeholder="Select Options"
                        />

                        <div style={{ marginTop: "10px" }}>
                            <strong>Selected Options:</strong>{" "}
                            {selectedOptions.map((option) => option.label).join(", ")}
                        </div>
                         
                        </div>
                      <div className="mb-20">
                        <label
                          htmlFor="desc"
                          className="form-label fw-semibold text-primary-light text-sm mb-8"
                        >
                          Description
                        </label>
                        <textarea
                          
                          className="form-control radius-8"
                          id="desc"
                          placeholder="Write description..."
                          name="description"
                        />
                      </div>
                      {
                      showAlertMessage.status === true?
                    <div
                          className={
                            showAlertMessage.message == 'error' ?
                            "alert alert-danger bg-danger-50 text-danger-600 border-danger-50 px-24 py-11 mb-0 fw-semibold text-lg radius-8 d-flex align-items-center justify-content-between mb-10":
                            "alert alert-success bg-success-50 text-success-600 border-success-50 px-24 py-11 mb-0 fw-semibold text-lg radius-8 d-flex align-items-center justify-content-between mb-10"
                          }
                          role="alert"
                      >
                         { showAlertMessage.desc }
                          <button type="button" onClick={()=>setshowAlertMessage(!showAlertMessage)} className="remove-button text-secondary-600 text-xxl line-height-1">
                              {" "}
                              <Icon icon="iconamoon:sign-times-light" className="icon" />
                          </button>
                      </div>:null
                      }
                      <div className="d-flex align-items-center justify-content-center gap-3">
                    
                        <button
                          type="submit"
                          className="btn btn-primary border border-primary-600 text-md px-56 py-12 radius-8"
                        >
                          Save
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </MasterLayout>
    </>
  );
};

export default AddAffiliates;
